/** Program */
const programModalFiltersToggle = document.getElementById('toggle-program-modal-filters');
const programModalFilters = document.getElementById('program-modal-filters');
const programModalOverlay = document.getElementById('modal-overlay');

if (programModalFiltersToggle) {
    programModalFiltersToggle.addEventListener('click', function () {
        if (document.body.classList.contains('programs-filters-open')) {
            document.body.classList.remove('programs-filters-open');
        } else {
            document.body.classList.add('programs-filters-open');
        }
    });

    const ModalFiltersApplyBtn = document.getElementById('apply-filters');

    if (ModalFiltersApplyBtn) {
        ModalFiltersApplyBtn.addEventListener('click', function () {
            document.body.classList.remove('programs-filters-open');
        });
    }
}

if (programModalOverlay) {
    programModalOverlay.addEventListener('click', () => {
        if (document.body.classList.contains('programs-filters-open')) {
            document.body.classList.remove('programs-filters-open');
        }
    });
}
